import React from 'react';

export const TaskHistoryPage: React.FC = () => {
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-4">작업 이력</h2>
      <p>작업 이력이 여기에 표시됩니다.</p>
    </div>
  );
};